import React, { useState, useEffect } from "react";
import { useAuthContext } from "hooks/useAuthContext";
import BlockIcon from "@mui/icons-material/Block";
import { useStudentContext } from "hooks/useStudentContext";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import { API_URL } from "../../../../config";
import { Box, Typography } from "@mui/material";

export default function useData() {
  const { user } = useAuthContext();
  const { students, dispatch } = useStudentContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await fetch(`${API_URL}/students/getstudents`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });

        const studentsjson = await response.json();

        if (response.ok) {
          dispatch({ type: "GET_STUDENTS", payload: studentsjson });
        } else {
          throw new Error("Failed to fetch students");
        }
      } catch (error) {
        console.error("Error fetching students:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchStudents();
    }
  }, [user, dispatch]);

  // Handle blocking/unblocking a student
  const toggleBlockStatus = async (studentId, isBlocked) => {
    try {
      const response = await fetch(
        `${API_URL}/students/std/${studentId}/block`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
          body: JSON.stringify({ is_blocked: !isBlocked }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update block status");
      }

      // Refetch students after the block status update
      fetchStudents();
    } catch (error) {
      console.error("Error updating block status:", error);
    }
  };

  // Function to refetch students from the server
  const fetchStudents = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/students/getstudents`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });

      const studentsjson = await response.json();

      if (response.ok) {
        dispatch({ type: "GET_STUDENTS", payload: studentsjson });
      } else {
        throw new Error("Failed to fetch students");
      }
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return {
      columns: [],
      rows1: [],
    };
  }

  const rows1 = students
    ? students
        .filter((item) => item.is_approved)
        .map((item) => ({
          name: item.studentname,
          email: item.email,
          regnumber: item.regNumber,
          programme: item.programme,
          phonenumber: item.phoneNumber,
          academicyear: item.academicyear,
          status: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent="approved"
                color="success"
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          action: (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Typography
                variant="body2"
                fontWeight="bold"
                color={item.is_blocked ? "success.main" : "warning.main"}
                sx={{ cursor: "pointer" }}
                onClick={() => toggleBlockStatus(item.id, item.is_blocked)}
              >
                {item.is_blocked ? "Unblock" : "Block"}
              </Typography>
              <Box>
                <BlockIcon
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                  fontSize="small"
                  color={item.is_blocked ? "success" : "warning"}
                  onClick={() => toggleBlockStatus(item.id, item.is_blocked)}
                />
              </Box>
            </div>
          ),
        }))
    : [];

  return {
    columns: [
      { Header: "Name", accessor: "name", align: "center" },
      { Header: "Email", accessor: "email", align: "center" },
      { Header: "Reg Number", accessor: "regnumber", align: "center" },
      { Header: "Programme", accessor: "programme", align: "center" },
      { Header: "Phone Number", accessor: "phonenumber", align: "center" },
      { Header: "Academic Year", accessor: "academicyear", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],
    rows1: rows1,
  };
}
